import { PaymentPlans } from '@pharmaplan/common';
import strings from '../../../localization';

export enum TableSections {
  header,
  subscriptionFee,
  contractFee,
  plan,
  benefits
}

export const planComparison = (basicFee: number, unlimitedFee: number) =>
  [
    {
      key: TableSections.header,
      rows: [
        {
          key: 1,
          label: strings.features,
        },
        {
          key: PaymentPlans.basic,
          label: strings.formatString(strings.planFormat, strings.standard),
        },
        {
          key: PaymentPlans.unlimited,
          label: strings.formatString(strings.planFormat, strings.unlimited),
        },
      ],
    },
    {
      key: TableSections.subscriptionFee,
      rows: [
        {
          key: 1,
          label: strings.subscriptionFee,
        },
        {
          key: 2,
          label: strings.free,
        },
        {
          key: 3,
          label: strings.formatString(strings.monthlyFee, unlimitedFee),
        },
      ],
    },
    {
      key: TableSections.contractFee,
      rows: [
        {
          key: 1,
          label: strings.perContractFee,
        },
        {
          key: 2,
          label: strings.formatString(strings.feePerContract, basicFee),
        },
        {
          key: 3,
          label: strings.unlimitedContractsIncluded,
        },
      ],
    },
    {
      key: TableSections.plan,
      rows: [
        {
          key: 1,
          label: strings.plan,
        },
        {
          key: 2,
          label: strings.payPerUse,
        },
        {
          key: 3,
          label: strings.unlimitedUsageUntilLastDay,
        },
      ],
    },
    {
      key: TableSections.benefits,
      rows: [
        {
          key: 1,
          label: strings.costBenefits,
        },
        {
          key: 2,
          label: strings.convenientForOccasionalUsers,
        },
        {
          key: 1,
          label: strings.significantSavingsForFrequentUsers,
        },
      ],
    },
  ];
